<template>
  <BaseButton
    v-bind="$attrs"
    :icon="iconName">
    <slot />
  </BaseButton>
</template>

<script setup lang="ts">
import BaseButton from "@/components/buttons/BaseButton.vue";
import { ref, useAttrs } from "vue";

const attrs = useAttrs();
const iconName = ref(Object.keys(attrs).find(key => key.startsWith("mdi-")));
</script>
